export default __webpack_public_path__ + "static/media/ISMO CLASS-2_SYLLABUS_2025-26.5181bc32.pdf";